import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import {PrimaryNavItem} from "../../models/primary-nav"
import connect from "./connect"

type BurgerPrimaryItemLinkProps = PrimaryNavItem & {
    itemKey: string
    siteUrl: string
    target: string
    index: number
    textAlignment: string
    chevronIconAltText: string
    realm: string
    variant: string
    iconsVersionPath: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}
export const BurgerPrimaryItemLink = memo(
    ({
        itemKey,
        index,
        title,
        linkColour,
        fontWeight,
        textAlignment,
        path,
        chevronIconAltText,
        realm,
        variant,
        iconsVersionPath,
        templating,
    }: BurgerPrimaryItemLinkProps) => {
        const TemplatedBurgerPrimaryItemLink = useTemplatedComponent(templating, MANIFEST)

        return (
            <Suspense>
                <TemplatedBurgerPrimaryItemLink
                    itemKey={itemKey}
                    index={index}
                    title={title}
                    linkColour={linkColour}
                    fontWeight={fontWeight}
                    textAlignment={textAlignment}
                    path={path}
                    chevronIconAltText={chevronIconAltText}
                    realm={realm}
                    variant={variant}
                    iconsVersionPath={iconsVersionPath}
                />
            </Suspense>
        )
    },
)

BurgerPrimaryItemLink.displayName = "BurgerPrimaryItemLink"

export default connect(BurgerPrimaryItemLink)
